var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from "styled-components";
import Icon from './IconBase';
function ShareIcon(_a) {
    var width = _a.width, height = _a.height, props = __rest(_a, ["width", "height"]);
    var size = width || height || 20;
    return (React.createElement(Icon, __assign({ "data-icon": 'share', viewBox: "0 0 20 20", width: size, height: size }, props),
        React.createElement("g", { fill: "none" },
            React.createElement("path", { fill: "currentColor", d: "M18.249 15.322c-1.026 0-1.934.49-2.511 1.247l-6.633-3.95c.075-.29.12-.593.12-.907 0-.091-.008-.18-.014-.27l6.636-3.998c.58.678 1.44 1.11 2.402 1.11 1.744 0 3.158-1.415 3.158-3.16 0-1.743-1.414-3.158-3.158-3.158-1.745 0-3.159 1.414-3.159 3.159 0 .346.057.678.16.99L8.67 9.796C8.031 8.78 6.903 8.102 5.614 8.102c-1.993 0-3.61 1.616-3.61 3.61 0 1.994 1.617 3.61 3.61 3.61 1.069 0 2.026-.467 2.687-1.205l6.895 3.566c-.067.255-.106.521-.106.797 0 1.745 1.415 3.159 3.159 3.159 1.744 0 3.159-1.414 3.159-3.159 0-1.744-1.415-3.158-3.16-3.158z", transform: "translate(-2 -2)" }))));
}
export default styled(ShareIcon)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var templateObject_1;
